import { type ErrorComponentProps, createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../../../app/i18n";
import { AdminLayout } from "../../../../areas/admin/layout/AdminLayout";
import { ForbiddenError, guard } from "../../../../shared/auth/guards";
import { AdminNotFound } from "../../../../shared/layout/NotFound";
import { NoAccess, RouteError } from "../../../../shared/layout/RouteError";

/**
 * Admin area (FE-14): guard `admin` first, so a seller gets the "no access" state with a link to
 * the map (FR-FE14-01, AC-01) and never downloads the admin catalog or chunks (NFR-FE14-01).
 */
export const Route = createFileRoute("/app/_seller/admin")({
  beforeLoad: async (args) => {
    await guard("admin", args);
    await loadNamespaces("admin");
  },
  component: AdminLayout,
  errorComponent: AdminError,
  notFoundComponent: AdminNotFound,
});

function AdminError(props: ErrorComponentProps) {
  if (props.error instanceof ForbiddenError) return <NoAccess home="/app/map" />;
  return <RouteError {...props} />;
}
